import ReactDOM from 'react-dom';
import { useEffect } from 'react';
import CloseIcon from "../images/icons/white-close.svg"

export default function Modal(props) {
    // Handle escape key
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                props.closeEvent();
            }
        };

        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [props.closeEvent]);

    const handleBackdropClick = (e) => {
        // Only close if clicking on the backdrop itself
        if (e.target === e.currentTarget) {
            props.closeEvent();
        }
    };

    const handleContentClick = (e) => {
        // Prevent closing when clicking modal content
        e.stopPropagation();
    };

    return ReactDOM.createPortal(
        <div 
          className={"fixed inset-0 z-[999] flex items-center justify-center p-4 bg-dark-blue/40 backdrop-blur overflow-y-auto"}
          onClick={handleBackdropClick}
          style={{ pointerEvents: 'auto' }}
        >
          <div 
            className="w-full max-w-6xl mx-auto my-8"
            onClick={handleContentClick}
          >
            <div className={"w-full bg-dark-purple/50 flex flex-row place-items-center justify-between px-6 py-4 rounded-t-xl"}>
                <div className={"flex-grow"}>{props.heading}</div>
                <button className={"px-3 py-2 rounded-lg bg-dark-blue/60 text-white hover:bg-dark-blue hover:text-yellow transition-all"} onClick={props.closeEvent}>
                    <img src={CloseIcon} alt='Close Image' className='h-6 w-6'/>
                </button>
            </div>
            <div className="w-full">
                {props.children}
            </div>
          </div>
        </div>,
        document.body
    );
}
